import BillInvoices from './BillInvoices';

export default BillInvoices;
